import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { Resource } from '@opentelemetry/resources';
import { BasicTracerProvider, SimpleSpanProcessor } from '@opentelemetry/sdk-trace-base';
import { CI_METRICS_OTEL_TOKEN, OTEL_COLLECTOR_URL, OTEL_SERVICE_NAME, SEMRESATTRS_SERVICE_NAME, } from './constants';
export { context, trace, propagation } from '@opentelemetry/api';
export let tracer;
export let tracesProvider;
export const forceFlush = () => tracesProvider.forceFlush();
export const init = ({ exporterOptions, serviceName, otelUrl, otelToken, dryRun, customExporters, }) => {
    tracesProvider = new BasicTracerProvider({
        resource: new Resource({
            [SEMRESATTRS_SERVICE_NAME]: serviceName || OTEL_SERVICE_NAME,
        }),
    });
    const authorization = otelToken || CI_METRICS_OTEL_TOKEN
        ? {
            Authorization: `Bearer ${otelToken || CI_METRICS_OTEL_TOKEN}`,
        }
        : {};
    const headers = {
        ...(exporterOptions?.headers || {}),
        ...authorization,
    };
    const exporters = customExporters || [];
    if (!dryRun) {
        const OTLPExporter = new OTLPTraceExporter({
            ...exporterOptions,
            url: `${otelUrl || OTEL_COLLECTOR_URL}/v1/traces`,
            headers,
        });
        exporters.push(OTLPExporter);
    }
    exporters.forEach((exporter) => tracesProvider.addSpanProcessor(new SimpleSpanProcessor(exporter)));
    tracesProvider.register();
    tracer = tracesProvider.getTracer(serviceName || OTEL_SERVICE_NAME);
};
export const destroy = () => {
    tracer = undefined;
    return tracesProvider.shutdown();
};
//# sourceMappingURL=traces.js.map